<ul class="navbar-nav">
  <li class="nav-item"
      *ngIf="isUserEntitledApiStore">
    <a id="navbarDropdown"
       class="nav-link"
       href=""
       role="button"
       data-toggle="dropdown"
       aria-haspopup="true"
       aria-expanded="false">
      <img class="aqx-user-avatar"
           [src]="user?.pictureUrl"
           data-toggle="tooltip"
           data-placement="left"
           title="{{user?.firstName}} ({{user?.email}})">
    </a>
    <ul class="dropdown-menu dropdown-menu-right"
        aria-labelledby="navbarDropdown">
      <li class="dropdown-header">
        <div class="text-nowrap">
          <strong>
            {{user?.firstName}}
          </strong>
        </div>
        <div class="text-nowrap">
          {{user?.email}}
        </div>
      </li>
      <li class="dropdown-divider"></li>
      <li class="dropdown-item">
        <a href=""
           (click)="signOut($event)">
          <i class="fas fa-sign-out-alt"></i>
          Sign Out
        </a>
      </li>
    </ul>
  </li>
  <li *ngIf="!isUserEntitledApiStore">
    <a class="btn btn-sm btn-primary"
       [href]="signInUrl">
      Sign In with Google
    </a>
  </li>
</ul>
